export default "__VITE_ASSET__BFfnjxnD__"